import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getClubCompetitions = async () => {
  const { data } = await axios.get(`${API_URL}/clubcompetition`);
  return data;
};
